// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"fdd69297","453":"b95f4bc7"}[chunkId] + ".chunk.js";
};